function usePermissions() {

    const isAdmin = localStorage.getItem('funcao') === 'A'

    return {
        isAdmin
    }
}

export { usePermissions }